module.exports = new __parcel__URL__("thank_heavens_text.f92bd76a.png").toString();